import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { selectShowCustomizeView } from 'selectors/mainView'
import { MovableModalContainer } from 'components/MovableModal'
import { CustomizationView } from './CustomizationView'

export const CustomizationViewContainer = () => {
  const customizationView = useSelector(selectShowCustomizeView)

  const location = useLocation()

  const isVisibleByUrl = useMemo(() => {
    const queryParams = new URLSearchParams(location.search)
    const stateRaw = queryParams.get('state')

    if (!stateRaw) return false

    try {
      const decodedBase64 = atob(stateRaw)
      const state = JSON.parse(decodedBase64)
      return state.customizeView === true
    } catch (e) {
      console.error('Error parsing parameters from URL: ', e)
      return false
    }
  }, [ location.search ])

  return (
    <MovableModalContainer
      visible={customizationView === 'theme' || isVisibleByUrl}
      windowId="CustomizationViewContainer"
    >
      <CustomizationView />
    </MovableModalContainer>
  )
}
